import { PostHogConfig } from 'posthog-js';

const gaId = import.meta.env.VITE_GA_ID;
const apiUrl = import.meta.env.VITE_API_URL;
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
const isProduction = import.meta.env.MODE === 'production';

const postHogApiKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const postHogHost = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

const postHogOptions: Partial<PostHogConfig> = {
  api_host: postHogHost,
  debug: !isProduction,
  autocapture: true,
  capture_pageview: true,
};

export { apiUrl, gaId, isProduction, sentryDsn, postHogOptions, postHogApiKey };
